import React from 'react';

const ResultadoSection = ({
  loading,
  responseText,
  documentData,
  tipoDocumento,
  arquivosAnexados,
  copyToClipboard,
  downloadDocument,
  gerarDocx
}) => {
  if (loading) {
    return (
      <div className="loading-generation">
        <span>⏳</span>
        <span>
          {tipoDocumento === 'procuracao'
            ? 'Gerando procuração...'
            : arquivosAnexados.length > 0
              ? 'Processando ficheiros...'
              : 'Gerando documento...'}
        </span>
      </div>
    );
  }

  if (!responseText) return null;

  return (
    <div className="resultado-container">
      <div className="resultado-actions">
        <h3>📋 Resultado da Geração</h3>
        <div className="action-buttons">
          <button className="action-btn copy-btn" onClick={copyToClipboard}>
            📋 COPIAR TEXTO
          </button>
          {documentData && tipoDocumento === 'procuracao' && (
            <button className="action-btn download-btn" onClick={downloadDocument}>
              💾 DOWNLOAD .DOCX
            </button>
          )}
          {tipoDocumento === 'outros' && !responseText.startsWith('#ERRO') && (
            <button className="action-btn download-btn" onClick={gerarDocx}>
              💾 GERAR .DOCX
            </button>
          )}
        </div>
      </div>
      <div className="resultado-content">
        <textarea className="response-textarea" value={responseText} readOnly rows={15} />
      </div>
    </div>
  );
};

export default ResultadoSection;
